<template>
    <div class="app-container">
        <el-row>
            <el-input style="max-width:168px; margin-right: 10px;" v-model="listQuery.user_name" placeholder="用户昵称"
                clearable />
            <el-select style="margin-right: 10px;" v-model="listQuery.type" placeholder="奖品类型" clearable>
                <el-option v-for="item in filterSettings.itemTypeSelectOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="handleSearch">搜索</el-button>
            <el-button type="warning" icon="el-icon-upload2" :loading="listLoading" @click="exportExcel">导出Excel</el-button>
        </el-row>
        <div class="table">
            <el-table v-loading="listLoading" :data="tableData" border fit highlight-current-row height="65vh">
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column label="用户头像" min-width="110" align="center">
                    <template #default="{ row: { user_info: { head_img } } }">
                        <el-image v-if="head_img" style="width: 58px; height: 58px" :src="head_img" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="user_info.name" label="用户昵称" min-width="110" align="center" />
                <el-table-column prop="created_at" label="抽奖时间" min-width="110" align="center" />
                <el-table-column label="奖品类型" min-width="110" align="center">
                    <template #default="{ row: { type } }">
                        <el-tag type="primary" size="medium">{{ checkType(type) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="picture" label="图片" min-width="110" align="center">
                    <template #default="{ row: { img } }">
                        <el-image style="width: 58px; height: 58px" :src="img" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="point" label="使用积分" min-width="110" align="center">
                    <template #default="{ row: { draw_type, integral } }">
                        <el-tag type="warning" size="medium">{{ draw_type == 1 ? '消耗次数' : `${integral}分` }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>

<script>
// 抽奖记录
import { sweepstakesRecord } from "@/api/draw"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        filterSettings: {
            username: "",
            winningName: "",
            stateSelected: null,
            itemTypeSelected: null,
            itemTypeSelectOptions: [
                {
                    value: 1,
                    label: "积分"
                },
                {
                    value: 2,
                    label: "实物"
                },
                {
                    value: 3,
                    label: "谢谢惠顾"
                }
            ]
        },
        listLoading: false,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            type: null,
            user_name: '',
        },
    }),
    methods: {
        getList() {
            this.listLoading = true;
            this.tableData = []
            sweepstakesRecord.list(this.listQuery).then(({ data }) => {
                this.tableData = data.data;
                this.total = data.total;
                this.listLoading = false;
            })
        },
        handleSizeChange(val) {
            this.listQuery.limit = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.listQuery.page = val
            this.getList()
        },
        checkType(type) {
            switch (Number(type)) {
                case 1: return '积分';
                case 2: return '实物';
                case 3: return '谢谢惠顾';
            }
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await sweepstakesRecord.list({ ...this.listQuery, page: 1, limit: total })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '用户昵称', '奖品类型', '使用积分', '抽奖时间'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.user_info.name,
                        item.type === 1 ? '积分' : item.type === 2 ? '实物' : item.type === 3 ? '谢谢惠顾' : '其它',
                        item.draw_type === 1 ? '消耗次数' : item.integral,
                        item.created_at
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "抽奖记录");
                XLSX.writeFile(wb, "抽奖记录.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    beforeMount() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.table {
    margin-top: 10px;
}
</style>